import React, { ReactElement, useState, useEffect, createRef, useRef, ReactNode } from 'react'
import { Table, Button, Modal, notification, Form, Row, Col, Input, Space, Select, Tag } from 'antd'
import { useSelector,useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd/es/form/Form'
import type { PaginationProps } from 'antd'
import moment from 'moment'
import ResizableTable from '@/components/resizableTable'
import { SmileOutlined } from '@ant-design/icons'
// import { getProjectInfoList } from '@/services/table.service'
import { getOnlineReview } from '@/services/progress.service'
import { IPagination, IProjectInfo } from '@/store/models/tableEdit.model'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
// import type { IColProperty } from '@/pages/table2SearchAll'
// import { wrapText } from '@/pages/table2SearchAll'
import type { IAppState } from '@/store/reducers'
import { getTechClassification } from '@/store/actions/tableEdit.action'

interface childrenType {
    title: string
    dataIndex: string
    key: string
    editable?: boolean
    className?: string
    width?: number
    ellipsis: { showTitle: boolean },
    filters?: {
        text: string
        value: number
    }[]
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onFilter?: (value: string, record: any) => boolean
    render?: any
}
interface IColProperty {
    title?: ReactNode | string
    className?: string
    editable?: boolean
    dataIndex?: string
    children?: childrenType[]
    filters?: {
        text: string
        value: string
    }[]
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onFilter?: (value: string | number | boolean, record: any) => boolean
}
type EditableTableProps = Parameters<typeof Table>[0]
type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>

export default function SelectTechListPop ({
    show,
    hide,
    checked,
    selectedKeys,
}: {
    show: boolean
    hide: any
    selectedKeys: any[]|undefined
    checked?: boolean
}): ReactElement {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [selectObj, setSelectObj] = useState<any>(null)
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [tableKey, setTableKey] = useState<string>('a')
    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState<any[]>([])
    const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>('radio')
    const [selectionKey, setSelectionKey] = useState<any[]>([])
    const [winH, setWinH] = useState(0)
    const { Option } = Select
    const [paginationInfo, setPaginationInfo] = useState<IPagination>({
        pageIndex: 1,
        pageSize: 6,
        total: 0
    })
    const [initFlg, setInitFlg] = useState(true)
    const classification = useSelector((state: IAppState) => state.tableEditData.techClassification)
    const [, setWorkClassArr] = useState<any []>([])
    const [searchValues, setSearchValues] = useState<any>({})
    const [selectRecord, setSelectRecord] = useState<any>()
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)

    const { i18n } = useTranslation()

    useEffect(() => {
        if(selectedKeys && selectedKeys.length > 0){
            setSelectionKey(selectedKeys)
        }else{
            setSelectionKey([])
        }
    }, [selectedKeys])
    
    useEffect(() => {
        if (initFlg) return
        const _classification = [...classification]
        const groupByCategory = _classification.reduce((group: any, product) => {
            const { classId } = product
            group[classId] = group[classId] || []
            group[classId].push(product)
            return group
        }, {})
        const _classArr: any[] = []
        Object.keys(groupByCategory).forEach(key => {
            _classArr.push(groupByCategory[key][0])
        })
        setWorkClassArr([..._classArr])
    }, [classification])

    const changeWorkGroup = (e:any)=>{
        setInitFlg(false)
        dispatch(getTechClassification({
            pageNo: 1,
            pageSize: 100,
            workGroupId: e
        }))
    }
    const formRef = createRef<FormInstance>()
    // pageSize 变更后，会重复触发 pageChange 事件
    const pageSizeChanged = useRef<boolean>(false)
    const closePop = () => {
        hide()
    }
    const allColumns: (ColumnTypes[number] & IColProperty)[] = [
        {
            title: () => <span>{t('proposalName')}</span>,
            dataIndex: 'proposalName',
            key: 'proposalName',
            width: 400,
            ellipsis: { showTitle: true },
            fixed: 'left',
            render (value: string, record: any) {
                if(Reflect.has(record, 'parent') && record.parent === null){
                    return <span>{value}</span>
                }else{
                    return (<>
                        <Tag color="error" style={{ marginRight: 4 }}>{t('secondReview')}</Tag><span>{value}</span>
                    </>)
                }
            }
        },
        {
            title: () => <span>{t('creator')}</span>,
            dataIndex: 'creator',
            key: 'creator',
            width: 200,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('Work Group')}</span>,
            dataIndex: 'workGroup',
            key: 'workgroup',
            width: 200,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value.workGroupName
            }
        },
        {
            title: () => <span>{t('reviewResult')}</span>,
            dataIndex: 'reviewResult',
            key: 'reviewResult',
            width: 150,
            render: (value: boolean) => {
                return value === null ? t('reviewResultNull') : (value ? t('reviewResultTrue') : t('reviewResultFalse'))
            }
        },
        {
            title: () => <span>{t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isDisruptive')}</span>,
            dataIndex: 'isDisruptive',
            key: 'isDisruptive',
            width: 150,
            render: (value: boolean) => {
                return value ? t('Yes') : t('No')
            }
        },
        {
            title: () => <span>{t('isDisruptiveResult') + t('reviewResult')}</span>,
            dataIndex: 'disruptiveReview',
            key: 'disruptiveReview',
            width: 120,
            render: (value: number,record:any) => {
                return !record.isDisruptive ? 'NA' : (record.reviewResult == null || value == null) ? 'NA' : (value >= 6) ? t('Yes') : t('No')
            }
        },
        {
            title: () => <span>{t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isCross')}</span>,
            dataIndex: 'isCross',
            key: 'isCross',
            width: 150,
            // ellipsis: { showTitle: true },
            render: (value: boolean) => {
                return value ? t('Yes') : t('No')
            }
        },
        {
            title: () => <span>{t('isCrossResult') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>,
            dataIndex: 'isCrossReview',
            key: 'isCrossReview',
            width: 120,
            // ellipsis: { showTitle: true },
            render: (value: boolean,record:any) => {
                return !record.isCross ? 'NA' : (record.reviewResult == null || value == null) ? 'NA' : value  ? t('Yes') : t('No')
            }
        },
        {
            title: () => <span>{t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}</span>,
            dataIndex: 'reviewDate',
            key: 'reviewDate',
            width: 200,
            ellipsis: { showTitle: true },
            render: (value: Date, record: any) => {
                return moment(value).format('YYYY-MM-DD') + (record.reviewDateHours ? ' ' + record.reviewDateHours : '')
            }
        },
        {
            title: () => <span>{t('feedDueDate')}</span>,
            dataIndex: 'tmtReviewDueDate',
            key: 'tmtReviewDueDate',
            width: 150,
            ellipsis: { showTitle: true },
            render: (value: Date) => {
                return moment(value).format('YYYY-MM-DD')
            }
        },
        {
            title: () => <span>{t('feedEndDate')}</span>,
            dataIndex: 'dueDate',
            key: 'dueDate',
            width: 150,
            ellipsis: { showTitle: true },
            render: (value: Date) => {
                return moment(value).format('YYYY-MM-DD')
            }
        },
    ]
    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    }
    const tailLayout = {
        wrapperCol: { offset: 7, span: 10 },
    }
    const getList = async (params: any) => {
        try {
            setLoading(true)
            const res = await getOnlineReview({
                ...params,
                reviewType: '2,4',
                pageNo: params?.pageIndex || paginationInfo.pageIndex,
                pageSize: params?.pageSize || paginationInfo.pageSize,
                reviewResult: true,
            }).finally(() => {
                setLoading(false)
            })
            console.log('getList: ', res)
            const projectInfoList = res.content
            setDataSource([...projectInfoList])
            setPaginationInfo({
                pageIndex: params?.pageIndex || paginationInfo.pageIndex,
                pageSize: params?.pageSize || paginationInfo.pageSize,
                total: res.totalElements
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 分页
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber: number): void => {
        if (pageSizeChanged.current) return
        getList({
            ...searchValues,
            ...paginationInfo,
            pageIndex: pageNumber
        })
    }
    const onPageSizeChange = (current: number, size: number) => {
        // 避免重复触发 pageChange 事件
        pageSizeChanged.current = true
        getList({
            ...searchValues,
            ...paginationInfo,
            pageIndex: current,
            pageSize: size
        })

        setTimeout(() => {
            pageSizeChanged.current = false
        }, 100)
    }

    const rowSelection = {
        onSelect:(record: any) =>{
            console.log('onSelect: ', record)
            setSelectRecord(record)
            setSelectionKey([record.id])
        },
        onChange: (selectedRowKeys: React.Key[], selectedRows: IProjectInfo[]) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
        },
    }
    const onFinish = async (values: any) => {
        console.log('onFinish: ', values)
        setSearchValues(values)
        getList({
            ...values,
            ...paginationInfo,
            pageIndex: 1,
        })
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        console.log('onFinishFailed: ', errorFields)
        if (errorFields.length) {
            const args = {
                message: t('FinishFailed'),
                description: '',
                icon: <SmileOutlined style={{ color: '#e1931e' }} />,
                duration: 3,
            }
            notification.open(args)
        }
    }
    const onReset = () => {
        formRef.current?.resetFields()
    }
    const onConfirm = () => {
        if(selectRecord){
            hide(selectRecord)
        }
    }

    useEffect(() => {
        getList(paginationInfo)
        const offsetH = 360
        setWinH(document.body.clientHeight - offsetH)
        const onResize = () => {
            setWinH(document.body.clientHeight - offsetH)
        }
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])
    useEffect(() => {
        console.log('winH: ', winH)
    }, [winH])
    useEffect(() => {
        if (show) {
            if (checked) {
                setSelectionType('checkbox')
            } else {
                setSelectionType('radio')
            }
        }
    }, [show])

    return (
        <Modal title={t('selectProposal')} visible={show}
            maskClosable={false}
            onOk={onConfirm}
            okText={t('confirm')}
            cancelText={t('cancel')}
            onCancel={closePop}
            width='90%'
            centered
        >
            <Form {...layout} ref={formRef}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="edit_table"
            >
                <Row>
                    <Col span={12}>
                        <Form.Item name="workGroupId" label={<span className='label'>{t('Work Group')}</span>}
                        >
                            <Select allowClear placeholder={t('Work Group Placeholder')} onChange={changeWorkGroup}>
                                {
                                    workgroupList.map(item => {
                                        return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                        
                    </Col>
                    <Col span={12}>
                        <Form.Item name="proposalName" label={<span className='label'>{t('proposalName')}</span>}>
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                    <Space size={20}>
                        <Button type="primary" htmlType="submit">{t('search')}</Button>
                        {/* <Button type="primary" onClick={onConfirm}>{t('confirm')}</Button> */}
                        <Button htmlType="button" onClick={onReset}>{t('reset')}</Button>
                    </Space>
                </Form.Item>
            </Form>
            <ResizableTable key={tableKey} scroll={{ x: '100%', y: winH }} bordered
                tableData={dataSource}
                cols={allColumns}
                loading={loading}
                rowKey='id'
                rowSelection={{
                    type: selectionType,
                    selectedRowKeys: selectionKey,
                    ...rowSelection,
                }}
                onRow={(record: any) => {
                    return {
                        onClick: () => {
                            console.log('record: ', record)
                            setSelectRecord(record)
                            setSelectionKey([record.id])
                        }
                    }
                }}
                pagination={{
                    current: paginationInfo.pageIndex,
                    pageSize: paginationInfo.pageSize,
                    total: paginationInfo.total,
                    showQuickJumper: true,
                    onChange: onPaginationChange,
                    showSizeChanger: true,
                    onShowSizeChange: onPageSizeChange,
                    showTotal: (total: number) => 
                        `${t('total')} ${total} ${t('items')}`
                }}
            />
        </Modal>
    )
}
